module.exports = __webpack_public_path__ + "img/place_yytgy.29447867.png";